<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<div class="DateFlex">
		<label>Start Date:</label>
		<p-calendar
			class="SmallFlex"
			showIcon="true"
			showButtonBar="true"
			[(ngModel)]="StartDate"
			name="StartDate"
			(ngModelChange)="onStartDateChange($event)"
		></p-calendar>

		<label class="LargeFlex">End Date:</label>
		<p-calendar
			class="SmallFlex"
			showIcon="true"
			showButtonBar="true"
			[(ngModel)]="EndDate"
			name="EndDate"
			(ngModelChange)="onEndDateChange($event)"
		></p-calendar>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstSchoolAlertTxn"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedSchoolAlertTxn"
		dataKey="SchoolAlertTxnID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--AlertTypeCD-->
				<th>
					<p-columnFilter field="AlertTypeCD" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterAlertTypeCD
								[ngModel]="value"
								[options]="lstAlertTypeCD"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--AlertTypeDesc-->
				<th>
					<p-columnFilter field="AlertTypeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterAlertTypeDesc
								[ngModel]="value"
								[options]="lstAlertTypeDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--SeverityDesc-->
				<th>
					<p-columnFilter field="SeverityDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSeverityDesc
								[ngModel]="value"
								[options]="lstSeverityDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--StartDT-->
				<th>
					<!-- <p-columnFilter type="text" field="StartDT" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--EndDT-->
				<th>
					<!-- <p-columnFilter type="text" field="EndDT" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--Comments-->
				<th>
					<p-columnFilter type="text" field="Comments" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--BusNbr-->
				<th>
					<p-columnFilter type="text" field="BusNbr" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--PersonName-->
				<th>
					<p-columnFilter type="text" field="PersonName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="AlertTypeCD">Type Code<p-sortIcon field="AlertTypeCD"></p-sortIcon></th>
				<th pSortableColumn="AlertTypeDesc">Type Description<p-sortIcon field="AlertTypeDesc"></p-sortIcon></th>
				<th pSortableColumn="Severity">Severity<p-sortIcon field="Severity"></p-sortIcon></th>
				<th pSortableColumn="StartDT">Start<p-sortIcon field="StartDT"></p-sortIcon></th>
				<th pSortableColumn="EndDT">End<p-sortIcon field="EndDT"></p-sortIcon></th>
				<th pSortableColumn="Comments">Comments<p-sortIcon field="Comments"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
				<th pSortableColumn="BusNbr">Bus<p-sortIcon field="BusNbr"></p-sortIcon></th>
				<th pSortableColumn="PersonName">Created By<p-sortIcon field="PersonName"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-SchoolAlertTxn>
			<tr [pSelectableRow]="SchoolAlertTxn" (dblclick)="onRowDblClick(SchoolAlertTxn)">
				<td *ngFor="let col of cols1" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ SchoolAlertTxn[col.field] }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="SchoolAlertTxn.Active == true ? 'Black' : 'Red'">
					{{ SchoolAlertTxn["ActiveDesc"] }}
				</td>

				<td *ngFor="let col of cols2" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ SchoolAlertTxn[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
